(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fk-footer-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fk-footer-directory')) {
    customElements.define('fk-footer-directory', class extends HTMLElement {
      connectedCallback() {
        this.media = matchMedia('(min-width: 750px)');
        this.update = () => this.querySelectorAll('.fk-directory__column').forEach(item => { item.open = this.media.matches; });
        this.media.addEventListener('change', this.update);
        this.update();
      }
      disconnectedCallback() { this.media.removeEventListener('change', this.update); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-legacy-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fk-legacy-video')) {
    customElements.define('fk-legacy-video', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('.fk-lg-video__poster');
        if (button) button.addEventListener('click', () => this.play(), { once: true });
      }

      play() {
        const id = encodeURIComponent(this.dataset.id || '');
        if (!id) return;
        const src = this.dataset.type === 'vimeo'
          ? `https://player.vimeo.com/video/${id}?autoplay=1&dnt=1`
          : `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        const frame = document.createElement('iframe');
        frame.src = src;
        frame.title = this.dataset.title || '';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.className = 'fk-lg-video__iframe';
        this.replaceChildren(frame);
        frame.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-selection-moments"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fk-selection-tabs')) {
    customElements.define('fk-selection-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-sel-tab]')];
        this.panels = [...this.querySelectorAll('[data-sel-panel]')];
        this.tablist = this.querySelector('[data-sel-tablist]');
        this.arrows = this.querySelector('[data-sel-arrows]');
        this.prev = this.querySelector('[data-sel-prev]');
        this.next = this.querySelector('[data-sel-next]');
        this.update = () => this.updateArrows();
        this.onClick = (event) => {
          const tab = event.target.closest('[data-sel-tab]');
          if (tab) this.select(this.tabs.indexOf(tab));
          if (event.target.closest('[data-sel-prev]')) this.scroll(-1);
          if (event.target.closest('[data-sel-next]')) this.scroll(1);
        };
        this.onKey = (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index < 0) return;
          const last = this.tabs.length - 1;
          const target = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: last }[event.key];
          if (target === undefined) return;
          event.preventDefault();
          this.select(target < 0 ? last : target > last ? 0 : target, true);
        };
        this.onBlockSelect = (event) => {
          const panel = event.target.closest && event.target.closest('[data-sel-panel]');
          if (panel && this.contains(panel)) this.select(this.panels.indexOf(panel));
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);
        this.panels.forEach((panel) => panel.querySelector('[data-sel-list]')?.addEventListener('scroll', this.update, { passive: true }));
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        window.addEventListener('resize', this.update);
        this.updateArrows();
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        window.removeEventListener('resize', this.update);
      }

      get list() {
        const panel = this.panels.find((item) => !item.hidden);
        return panel && panel.querySelector('[data-sel-list]');
      }

      select(index, focus = false) {
        const tab = this.tabs[index];
        if (!tab) return;
        this.tabs.forEach((item, i) => {
          const active = i === index;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          if (this.panels[i]) this.panels[i].hidden = !active;
        });
        if (focus) tab.focus();
        const left = tab.offsetLeft - this.tablist.offsetLeft;
        if (left < this.tablist.scrollLeft || left + tab.offsetWidth > this.tablist.scrollLeft + this.tablist.clientWidth) {
          this.tablist.scrollTo({ left: Math.max(0, left - 24), behavior: 'smooth' });
        }
        this.updateArrows();
      }

      scroll(direction) {
        const list = this.list;
        if (list) list.scrollBy({ left: direction * list.clientWidth, behavior: 'smooth' });
      }

      updateArrows() {
        const list = this.list;
        const overflow = list && list.scrollWidth > list.clientWidth + 2;
        this.arrows.hidden = !overflow;
        if (!overflow) return;
        this.prev.disabled = list.scrollLeft <= 2;
        this.next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fk-timeline')) {
    customElements.define('fk-timeline', class extends HTMLElement {
      connectedCallback() {
        const tab = this.querySelector('.fk-tl__related-list [aria-current]');
        const tabs = tab && tab.closest('ul');
        if (tabs && tabs.scrollWidth > tabs.clientWidth + 1) tabs.scrollLeft = tab.offsetLeft - (tabs.clientWidth - tab.offsetWidth) / 2;
        this.strip = this.querySelector('[data-tl-strip]');
        this.links = new Map();
        this.querySelectorAll('[data-tl-link]').forEach((link) => this.links.set(decodeURIComponent(link.hash.slice(1)), link));
        this.items = [...this.querySelectorAll('[data-tl-item]')];
        if (!this.items.length) return;
        this.scheduleUpdate = () => {
          if (this.frame != null) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateCurrentYear();
          });
        };
        document.addEventListener('scroll', this.scheduleUpdate, { passive: true, capture: true });
        window.addEventListener('resize', this.scheduleUpdate);
        this.scheduleUpdate();
      }

      disconnectedCallback() {
        document.removeEventListener('scroll', this.scheduleUpdate, true);
        window.removeEventListener('resize', this.scheduleUpdate);
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      updateCurrentYear() {
        const offset = (parseFloat(getComputedStyle(this.items[0]).scrollMarginTop) || 0) + 2;
        let current = this.items[0];
        for (const item of this.items) {
          if (item.getBoundingClientRect().top > offset) break;
          current = item;
        }
        this.activate(current.id);
      }

      activate(id) {
        if (id === this.active) return;
        this.active = id;
        this.links.forEach((link, key) => {
          if (key === id) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        const link = this.links.get(id);
        const strip = this.strip;
        if (!link || !strip) return;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        if (strip.scrollWidth > strip.clientWidth + 1) {
          strip.scrollTo({ left: link.offsetLeft - (strip.clientWidth - link.offsetWidth) / 2, behavior });
        } else if (strip.scrollHeight > strip.clientHeight + 1) {
          strip.scrollTo({ top: link.offsetTop - (strip.clientHeight - link.offsetHeight) / 2, behavior });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
